
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateMeetingParticipantDtoFormGroup() {
return new FormGroup({
    meetingId: new FormControl<number | undefined>(undefined, [Validators.required]),
    userId: new FormControl<number | undefined>(undefined),
    contactId: new FormControl<number | undefined>(undefined),
    role: new FormControl<string | undefined>(''),
})
;
}
      